import useDebounce from '@/hooks/useDebounce.ts';
import {Button, InputGroup} from '@blueprintjs/core';
import {ChangeEventHandler, CSSProperties, ReactElement, useCallback, useState} from 'react';

interface Props {
	onSearch: (value: string) => void,
	debounce?: boolean,
	debounceTimeout?: number,
	style?: CSSProperties,
}

export default function Search({onSearch, debounce = true, debounceTimeout = 300, style}: Props): ReactElement {
	const [text, setText] = useState('');

	const onSearchInternal = useDebounce(onSearch, debounce ? debounceTimeout : 0);

	const onTextChange: ChangeEventHandler<HTMLInputElement> = useCallback(event => {
		setText(event.currentTarget.value);
		onSearchInternal(event.currentTarget.value.toLocaleLowerCase());
	}, [onSearchInternal]);

	const onTextClear = useCallback(() => {
		setText('');
		onSearchInternal('');
	}, []);

	return (
		<InputGroup
			leftIcon="search"
			value={text}
			onChange={onTextChange}
			rightElement={(
				<Button icon="cross" variant="minimal" onClick={onTextClear} />
			)}
			style={style ?? {width: 400}}
		/>
	);
}
